import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Stock.css'; // Assuming you create a Stock.css file for additional styling
import baseURL from './baseUrl';

const Stock = () => {
  const [stockData, setStockData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false); // To show a loading state when deleting

  // Fetch stock data
  const fetchStock = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(`${baseURL}/api/stocks/current`);
      setStockData(response.data);
    } catch (error) {
      console.error('Error fetching stock data:', error.response?.data?.message || error.message);
      setError(error.response?.data?.message || 'Error fetching stock data');
    }
    setLoading(false);
  };

  // Delete all stock
  const deleteAllStock = async () => {
    const confirmDelete = window.confirm('Are you sure you want to delete all stock? This action cannot be undone.');
    if (!confirmDelete) return;

    setDeleting(true);
    try {
      const response = await axios.delete(`${baseURL}/api/stocks/deleteAll`);
      alert(response.data.message);
      // Re-fetch stock data after deletion
      fetchStock();
    } catch (error) {
      console.error('Error deleting all stock:', error.response?.data?.message || error.message);
      setError(error.response?.data?.message || 'Error deleting all stock');
    }
    setDeleting(false);
  };

  useEffect(() => {
    // Fetch stock data on component mount
    fetchStock();
  }, []);

  // Check if stockData and its nested properties are defined before rendering
  const hasStockData = stockData && stockData.stock;

  return (
    <div className="container mt-5">
      <h2 className="mb-4 text-center">Current Stock</h2>

      {loading && <p className="text-center">Loading...</p>}
      {error && <div className="alert alert-danger text-center">{error}</div>}

      {hasStockData && (
        <div className="card shadow-sm mb-4">
          <div className="card-body">
            {stockData.client ? (
              <>
                <h5 className="card-title text-primary">Client Stock Details</h5>
                <p><strong>Name:</strong> {stockData.client.name}</p>
                <p><strong>Mobile No:</strong> {stockData.client.mobileNo}</p>
                <p><strong>Total Gold:</strong> {stockData.stock.gold} grams</p>
                <p><strong>Latest Rate:</strong> {stockData.stock.rate} per gram</p>
                <p><strong>Total Pure Weight:</strong> {Number(stockData.stock.pureWeight).toFixed(3)} grams</p>
                <p><strong>Total Langdi Weight:</strong> {Number(stockData.stock.langdiWeight).toFixed(3)} grams</p>
                <p><strong>Total Cash Amount:</strong> {Math.round(stockData.stock.cashAmount)}</p>
                <h6 className="mt-4 text-success">Transactions:</h6>
                <ul className="list-group">
                  {stockData.transactions && stockData.transactions.map((transaction, index) => (
                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <strong>Date:</strong> {new Date(transaction.date).toLocaleDateString()} <br />
                        <strong>Gold:</strong> {transaction.gold} grams <br />
                        <strong>Rate:</strong> {transaction.rate} per gram <br />
                        <strong>Receipt No:</strong> {transaction.receiptNo} <br />
                        <strong>Total:</strong> {transaction.total} <br />
                        <strong>Type:</strong> {transaction.type}
                      </div>
                      <span className={`badge ${transaction.type === 'buy' ? 'bg-success' : 'bg-danger'}`}>{transaction.type}</span>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <>
                <h5 className="card-title text-primary">General Stock Details</h5>
                <p><strong>Total Pure Weight:</strong> {Number(stockData.stock.pureWeight).toFixed(3)} grams</p>
                <p><strong>Total Langdi Weight:</strong> {Number(stockData.stock.langdiWeight).toFixed(3)} grams</p>
                <p><strong>Total Cash Amount:</strong> {Math.round(stockData.stock.cashAmount)}</p>
                {Array.isArray(stockData.stock.articles) && stockData.stock.articles.length > 0 && (
                  <>
                    <h6 className="mt-3">Articles (PCS)</h6>
                    <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Article</th>
                          <th>PCS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {stockData.stock.articles.map((item) => (
                          <tr key={String(item.article || item.name)}>
                            <td>{item.name}</td>
                            <td>{item.pcs}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
              </>
            )}

            {/* Button to Delete All Stock */}
            <div className="text-center mt-4">
              <button
                onClick={deleteAllStock}
                className="btn btn-danger"
                disabled={deleting}
              >
                {deleting ? 'Deleting...' : 'Delete All Stock'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Stock;
